const icon = require('vue-svgicon');
icon.register({
    'sort-desc': {
        width: 18,
        height: 18,
        viewBox: '0 0 18 18',
        data: `<path pid="0" clip-rule="evenodd" d="M10.427 11.237a.544.544 0 010 .77l-4.244 4.235-.003.001s-.002 0-.003.002a.53.53 0 01-.768 0l-.003-.002h-.002L1.16 12.006a.544.544 0 11.771-.77l3.329 3.322V2.033a.534.534 0 011.067 0v12.526l3.329-3.322a.548.548 0 01.77 0zM8.995 2.566h7.471a.534.534 0 100-1.066H8.995a.534.534 0 100 1.066zm7.471 3.194H8.995a.533.533 0 110-1.065h7.471a.533.533 0 110 1.065zM8.995 8.956h7.471a.533.533 0 100-1.065H8.995a.533.533 0 100 1.065zm3.202 3.195h4.27a.533.533 0 100-1.065h-4.27a.533.533 0 100 1.065zm4.27 2.13h-6.405a.533.533 0 100 1.065h6.404a.533.533 0 100-1.065z"/>`,
    },
});
